/* eslint-disable @typescript-eslint/member-ordering */
/// <reference types="@types/jquery" />
/// <reference types="@types/slick-carousel" />
import { Component, OnInit, HostListener, AfterViewInit, ViewChild, ElementRef, OnDestroy, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {
  Color, Type, PreProcessSettings,
  Category, Region, Classification, MessageModal, Regulation, Vehicle
} from 'src/app/core/models';
import {
  ReasonService, AlertService, ModalService, ColorService, PreProcessSettingsService,
  TypeService, CategoryService, BrandModelService, ClassificationService, StorageService,
  StorageKey, ContractService, ProcessViolationService, RegulationService,
  LaneService
} from 'src/app/core/services';
import { CommentPanelComponent } from '../comment-panel/comment-panel.component';
import { SearchPlatePanelComponent } from '../search-plate-panel/search-plate-panel.component';
import { HistoryPanelComponent } from '../history-panel/history-panel.component';
import { PlateService } from 'src/app/core/services/plate.service';
import { City } from 'src/app/core/models/City';
import { CityService } from 'src/app/core/services/city.service';
import * as _ from 'lodash';
import { RegionService } from 'src/app/core/services/region.service';
import { StateService } from 'src/app/core/services/state.service';
import { State } from 'src/app/core/models/State';
import { Violation, AlertType, AlertItem, ComponentModal, } from 'src/app/core/models';
import { ViolationService } from 'src/app/core/services/violation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { isEqual, cloneDeep } from 'lodash';
import {
  MessageDuplicateViolationModalComponent
} from 'src/app/modals/message-duplicate-violation-modal/message-duplicate-violation-modal.component';
import { ViolationFilter } from 'src/app/core/interface/ViolationFilter';
import { BrandInternal } from 'src/app/core/models/BrandInternal';
import { BrandInternalService } from 'src/app/core/services/brandInternal.service';
import moment from 'moment';
import { Gb } from 'src/app/core/services/growthbook.service';
import { MessageSearchPlateFailedComponent } from 'src/app/modals/message-search-plate-failed/message-search-plate-failed.component';

@Component({
  selector: 'app-typing',
  templateUrl: './typing.component.html',
  styleUrls: ['./typing.component.sass']
})
export class TypingComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('reasonInput', { static: false }) reasonInput: ElementRef;
  @ViewChild('confirmButton', { static: false }) confirmButton: ElementRef;
  @ViewChild('refuseButton', { static: false }) refuseButton: ElementRef;
  @ViewChild('plateInputElement', { static: false }) set plateInputElement(content) {
    if (content == null) {
      this._plateInputElement = content;
      return;
    }
    if (this._plateInputElement != null) {
      return;
    }
    this._plateInputElement = content;
    this.setPlateFocus();
  }

  get plateInputElement() {
    return this._plateInputElement;
  }

  public _plateInputElement;
  public plateInput: HTMLInputElement;
  public formGroup: FormGroup;
  public violation: Violation = new Violation();
  public violations: Violation[] = [];
  public preProcessSettings: PreProcessSettings;
  public i = 0;
  public files = [];
  public secondFiles = [];
  public reasons = [];
  public reasonsAll = [];
  public types: Array<Type>;
  public colors: Array<Color>;
  public brandModels = [];
  public brandModelsAll = [];
  public brandInternalModels: Array<BrandInternal> = [];
  public cities: Array<City>;
  public categories: Array<Category>;
  public regions: Array<Region>;
  public states: Array<State>;
  public classifications: Array<Classification>;
  public showingCities: Array<City>;
  public filters: ViolationFilter;
  public showingStates: Array<State>;
  public requiredFields = [];
  public hasSearch = false;
  public hasWhiteList = false;
  public validatorsDisabled = false;
  public imagesSettings: {
    [type: string]: {
      blur: { positions: [{ width: number; height: number; x: number; y: number }] };
      contrast: number; brightness: number; restore?: boolean;
    };
  };
  public isBlurEnabled = false;
  public isClipEnabled = false;
  public contractId = '';
  public refuseLoading = false;
  public acceptLoading = false;
  public violationsSteps = null;
  public regionId = null;
  public stateTextCities;
  public sessionId = null;
  public violationIdsProcessed = [];
  public isLoadListViolation = false;
  public violationLoadError = false;
  public changesPermited = true;
  public violationProcessed = false;
  public isChangePlate = false;
  public formEdited = false;
  public regulationByIds: { [params: string]: Regulation } = {};
  public isSearchPlate = false;
  public cetModels = false;
  public vehicleData: Vehicle;
  public vehicleDataSearch = false;
  public plateNotFoundReasonCode = null;
  public whitelistReasonCode = null;
  public incompleteVehicleDataReasonCode = null;
  public viewSearchBrandModels = false;
  public currentBrandModelCode: any;
  public hideButton = false;
  public plateValid: boolean;
  public allowInputNotFoundVehicle = false;
  public enabledVehicleForeign = false;
  public requiredFieldsVehicle = [];
  public requiredFieldsVehicleForeign = [];
  public searchVehicle: any;
  public reasonInputSelected = false;
  public gb: Gb;
  // features
  public ecs3916: boolean;
  public isWeighClass = false;
  public lanesCode: any = [];
  public enabledWeightClass = false;
  public loading = false;

  private loadPromise = null;
  private limit = '5';
  private next = null;
  private isDouble = false;
  private urlSegment = '';
  private isModified = false;
  private stepGroup;
  // eslint-disable-next-line @typescript-eslint/ban-types
  private plateRegex = null;
  private timeoutId = null;
  private expired = false;
  private placeDebouncer = null;
  private plateSearchPromise = null;
  private plateSearchFoundFields = [];
  private plateFound = true;
  private disabledRequiredFields: { [params: string]: any } = {};
  private skipPlateSearch = false;

  @Output() violationStatus: string;

  constructor(
    private formBuilder: FormBuilder,
    public activatedRoute: ActivatedRoute,
    private router: Router,
    private violationService: ViolationService,
    private reasonService: ReasonService,
    private modalService: ModalService,
    private preProcessSettingsService: PreProcessSettingsService,
    private alertService: AlertService,
    private plateService: PlateService,
    private colorService: ColorService,
    private typeService: TypeService,
    private categoryService: CategoryService,
    private brandModelService: BrandModelService,
    private classificationService: ClassificationService,
    private cityService: CityService,
    private regionService: RegionService,
    private storageService: StorageService,
    private stateService: StateService,
    private contractService: ContractService,
    private processViolationService: ProcessViolationService,
    private regulationService: RegulationService,
    private brandInternalService: BrandInternalService,
    private laneService: LaneService,
  ) {
    this.gb = new Gb();
  }

  async ngOnInit() {
    this.loading = true;
    await this.gb.init();

    this.processViolationService.getFilterProcessViolation()
      .pipe()
      .subscribe((result: any) => this.filters = result);
    if (this.filters === null) {
      this.router.navigate([`../../../pre-process`], { relativeTo: this.activatedRoute });
    }
    this.contractId = this.activatedRoute.snapshot.params.contractId;
    this.setInactivity();
    const promises = [];
    promises.push(this.contractService.getById(this.contractId));
    await this.preProcessSettingsService.getById(this.contractId).then(preProcessSettings => {
      this.preProcessSettings = preProcessSettings;
      this.requiredFields = preProcessSettings.requiredFields || [];
      this.requiredFieldsVehicle = preProcessSettings.requiredFields || [];
      this.requiredFields.forEach(field => {
        this.disabledRequiredFields[field] = true;
      });
      this.hasSearch = preProcessSettings.vehicleDataSearch !== 'disabled';
      this.hasWhiteList = preProcessSettings.enabledWhiteList;
      this.isBlurEnabled = this.preProcessSettings.imageEdit?.blur;
      this.isClipEnabled = this.preProcessSettings.imageEdit?.clip;
      this.violationsSteps = this.preProcessSettings.violationSteps;
      this.enabledVehicleForeign = this.preProcessSettings.enabledVehicleForeign;
      this.requiredFieldsVehicleForeign = (this.enabledVehicleForeign && this.preProcessSettings.requiredFieldsVehicleForeign) || [];
      if (this.preProcessSettings?.vehicleDataSearch !== 'disabled') {
        this.vehicleDataSearch = true;
      }
      if (this.preProcessSettings?.vehicleDataSearch === 'disabled') {
        this.allowInputNotFoundVehicle = true;
      } else {
        this.allowInputNotFoundVehicle = this.getValue(this.preProcessSettings, 'allowInputNotFoundVehicle') || this.enabledVehicleForeign;
      }

      this.enabledWeightClass = this.preProcessSettings?.weightClass?.enabled;
      if (this.enabledWeightClass) {
        const laneIds = this.preProcessSettings?.weightClass?.laneIds;
        if (laneIds?.length > 0) {
          const params = {};
          params['id[in]'] = `[${laneIds}]`;
          this.laneService.list(params).then(res => {
            this.lanesCode = res.result.map(lane => lane.code);
          });
        }
      }

    });

    promises.push(this.regionService.getAll().then(regions => {
      this.regions = regions;
      this.stateService.getAll({ regionId: regions[0].id }).then(states => {
        this.states = states;
        this.showingStates = states;
      }).catch(error => {
        console.error(error);
      });
      this.regulationService.getAll({ regionId: this.regions[0].id }).then(regulations => {
        regulations.map(regulation => {
          if (this.regulationByIds[regulation.id] == null) {
            this.regulationByIds[regulation.id] = regulation;
          }
        });
      });
      this.cities = this.storageService.get(StorageKey.cities) || [];
      if (this.cities.length === 0) {
        this.cityService.getAll({ regionId: this.regions[0].id }).then(res => {
          this.cities = _.sortBy(res, 'name');
        }).catch(error => {
          console.error(error);
        });
      } else {
        let cities = [];
        Object.keys(this.cities).map(stateId => {
          cities = cities.concat(this.cities[stateId]);
        });
        this.cities = _.sortBy(cities, 'name');
        return regions;
      }
      return regions;
    }).catch(error => {
      console.error(error);
    }));
    const routeCurrent = this.activatedRoute.snapshot.url[0] || { path: '' };
    this.urlSegment = 'typing';
    this.createForm();
    this.setRequiredFields();

    this.reasonService.getAll({
      contractId: this.contractId,
      order: 'code',
      'enabled[bool]': 'true'
    }).then(data => {
      this.reasons = data.sort((a, b): any => Number(a.code) - Number(b.code));
      this.reasonsAll = this.reasons;
      if (this.preProcessSettings?.plateNotFoundReasonId != null) {
        const reason = this.reasons.find(r => r.id === this.preProcessSettings.plateNotFoundReasonId);
        this.plateNotFoundReasonCode = reason?.code;
      }
      if (this.preProcessSettings?.whitelistReasonId != null) {
        const reason = this.reasons.find(r => r.id === this.preProcessSettings.whitelistReasonId);
        this.whitelistReasonCode = reason?.code;
      }
      const incompleteVehicleDataReasonId = this.getValue(this.preProcessSettings, 'incompleteVehicleDataReasonId');
      if (incompleteVehicleDataReasonId != null) {
        const reason = this.reasons.find(r => r.id === incompleteVehicleDataReasonId);
        this.incompleteVehicleDataReasonCode = reason?.code;
      }

    });
    this.stepGroup = routeCurrent.path;
    this.getViolations(true).catch(err => { }).then(() => {
      this.loading = false;
    });
    Promise.all(promises).then(results => {
      const contract = results[0];
      this.regionId = contract.regionId;
      const regions = results[1];
      const region = regions.find(r => r.id === contract.regionId);
      this.colorService.getAll({ regionId: region.id, order: 'id' }).then(colors => {
        this.colors = _.sortBy(colors, 'code');
      });
      this.typeService.getAll({ regionId: region.id }).then(types => {
        this.types = _.sortBy(types, 'code');
      });
      this.categoryService.getAll({ regionId: region.id }).then(categories => {
        this.categories = _.sortBy(categories, 'code');
      });
      this.brandModelService.list({ regionId: region.id, limit: '500' }).then(res => {
        this.brandModels = _.sortBy(res.result, 'code');
        this.brandModelsAll = _.sortBy(res.result, 'code');
      });
      this.classificationService.getAll({ regionId: region.id }).then(classifications => {
        this.classifications = _.sortBy(classifications, 'code');
      });
      if (region == null) {
        return;
      }
      this.plateRegex = region.plateRegex;
      if (this.formGroup != null) {
        const plateControl = this.formGroup.get('plate');
        plateControl.setValidators([plateControl.validator, Validators.pattern(this.plateRegex)]);
      }
    });
  }

  ngOnDestroy(): void {
    const user = this.storageService.get(StorageKey.currentUser);
    if (user == null || user.id == null) {
      return;
    }

    const userId = user.id;
    const violationIds = this.violations.map(v => v.id);
    this.violationService.unlock(userId, violationIds);
    clearTimeout(this.timeoutId);
  }

  unlock() {
    const user = this.storageService.get(StorageKey.currentUser);
    const violationIds = this.violations.map(v => v.id);
    this.violationService.unlock(user.id, violationIds);
  }

  ngAfterViewInit(): void {
    this.setPlateFocus();
  }

  getQueryParams() {
    const queryParams: any = {
      contractId: this.contractId,
      lock: 'true',
      stepGroup: this.stepGroup,
      limit: this.limit
    };
    if (this.filters.hasOwnProperty('equipmentsIds') && this.filters.equipmentsIds) {
      queryParams['equipment.id[in]'] = `[${this.filters.equipmentsIds}]`;
    }
    if (this.filters.hasOwnProperty('laneIds') && this.filters.laneIds) {
      queryParams['laneCode[in]'] = `[${this.filters.laneIds.join()}]`;
    }
    if (this.filters.hasOwnProperty('regulationsIds') && this.filters.regulationsIds) {
      queryParams['regulationId[in]'] = `[${this.filters.regulationsIds.join()}]`;
    }
    if (this.filters.hasOwnProperty('startDate') && this.filters.startDate) {
      queryParams['date[gte]'] = this.filters.startDate;
    }
    if (this.filters.hasOwnProperty('endDate') && this.filters.endDate) {
      queryParams['date[lte]'] = this.filters.endDate;
    }

    queryParams.order = 'date';
    return queryParams;
  }

  backToFilter() {
    this.processViolationService.emitFilterProcessViolation(null);
    this.router.navigate([`../../${this.stepGroup}`], { relativeTo: this.activatedRoute, queryParams: { contractId: this.contractId } });
  }

  getViolations(isFirst = false, isRetry = false) {
    this.violationLoadError = false;
    if (this.loadPromise) {
      return this.loadPromise;
    }
    const queryParams = this.getQueryParams();
    if (isFirst && this.violations.length === 0) {
      this.loadPromise = this.violationService.getLockedViolationsByMe(null, queryParams).then(async data => {
        let next = data.next;
        if (next == null && data.result.length === 0) {
          this.isLoadListViolation = true;
          return this.loadPromise = this.violationService.list(queryParams).then(item => {
            this.next = item.next;
            this.isLoadListViolation = false;
            return item;
          });
        } else {
          while (next != null) {
            const nextData = await this.violationService.getLockedViolationsByMe(next, queryParams);
            if (nextData && nextData.result != null) {
              data.result = data.result.concat(nextData.result);
            }
            next = nextData && nextData.next;
          }
        }
        return data;
      }).catch(async err => {
        if (err.status === 404) {
          this.isLoadListViolation = true;
          this.loadPromise = this.violationService.list(queryParams).then(data => {
            this.next = data.next;
            this.isLoadListViolation = false;
            return data;
          });
        }
      });
    } else {
      this.isLoadListViolation = true;
      this.loadPromise = this.violationService.list(queryParams).then(data => {
        this.next = data.next;
        this.isLoadListViolation = false;
        return data;
      });
    }
    return this.loadPromise.then(async data => {
      this.loadPromise = null;
      this.violations = this.violations.concat(data.result);
      if (isFirst) {
        const violation = this.violations[0];
        if (violation == null) {
          await this.getViolations().catch(err => { });
        }
        if (violation != null) {
          this.setForm(violation);
        }
      }
      this.preloadFiles(data.result);
      if (this.i >= this.violations.length - 1) {
        this.alertService.show(new AlertItem('NoViolationsTyping', AlertType.danger));
      }
    }).catch(async err => {
      this.loadPromise = null;
      if (isRetry === false) {
        await this.getViolations(false, true).then(() => {
          // this.i++;
          this.setForm(this.violations[this.i]);
        });
      } else {
        this.alertService.show(new AlertItem('ViolationListError', AlertType.danger));
        this.violationLoadError = true;
        console.error(err);
        throw err;
      }
    });
  }

  getImageEdit(event) {
    if (event == null) {
      return;
    }
    this.imagesSettings = event;
  }

  get typingValid() {
    if (this.formGroup == null) {
      return false;
    }
    if (this.preProcessSettings != null &&
      this.preProcessSettings.allowInputNotFoundVehicle !== true &&
      this.plateFound === false) {
      return false;
    }
    const reasonControl = this.formGroup.get('reasonCode');
    if (reasonControl && reasonControl.value != null && reasonControl.value !== '') {
      return false;
    } else {
      return this.formGroup.valid;
    }
  }

  get verifyValidation() {
    if (this.violation == null) {
      return false;
    }
    const newViolation = this.getViolation();
    const oldReasonCode = this.violation && this.violation.reason && this.violation.reason.code;
    const newReasonCode = this.formGroup && this.formGroup.get('reasonCode').value || undefined;
    return isEqual(newViolation, this.violation) && oldReasonCode === newReasonCode;
  }

  setPlateFocus() {
    if (this.plateInputElement == null) {
      return;
    }
    if (this.plateInput == null) {
      const element = this.plateInputElement.nativeElement;
      this.plateInput = element.querySelector('input') as HTMLInputElement;
    }
    if (this.plateInput != null) {
      this.plateInput.focus();
    }
  }

  loadMoreViolations() {
    if (this.loadPromise != null) {
      return this.loadPromise;
    }
    const queryParams = this.getQueryParams();
    this.loadPromise = this.violationService.list(queryParams).then(data => {
      this.loadPromise = null;
      this.violations = this.violations.concat(data.result);
      this.preloadFiles(data.result);
      if (this.i >= this.violations.length - 1) {
        this.alertService.show(new AlertItem('NoViolationsTyping', AlertType.danger));
      }
    }).catch(err => {
      this.loadPromise = null;
      throw err;
    });
    return this.loadPromise;
  }

  preloadFiles(violations) {
    setTimeout(() => {
      const violation = violations.shift();
      if (violation && violation.files != null) {
        violation.files.forEach(f => {
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.src = f.urlCurrent || f.urlDecrypted;
        });
      }
      if (violations.length > 0) {
        this.preloadFiles(violations);
      }
    }, 50);
  }

  get form() {
    return this.formGroup.controls;
  }

  createForm() {
    this.formGroup = this.formBuilder.group({
      plate: ['', [Validators.pattern(this.plateRegex)]],
      colorCode: [''],
      year: [''],
      brandModelCode: [''],
      displayBrandModelCode: [''],
      categoryCode: [''],
      classificationCode: [''],
      typeCode: [''],
      cityCode: [''],
      stateId: [''],
      regionCode: [''],
      regionId: ['Brasil'],
      reasonCode: [''],
      foreignPlate: [false],
      modelYear: [''],
      chassis: [''],
      uf: ['']
    });
    this.formGroup.valueChanges.subscribe(value => {
      this.isModified = true;
      this.editEvent('plate');
    });
    this.formGroup.get('foreignPlate').valueChanges.subscribe((value) => {
      if (!this.violationIdsProcessed.includes(this.violation.id) && !this.isViolationInStandBy()) {
        this.disableValidators();
        this.resetForm();
      }
      this.plateSearchFoundFields = [];
      const enabled = this.gb.isOn('ECS-4796');
      if (enabled) {
        const plate = this.formGroup.get('plate');
        if (!value) {
          plate.setValidators([Validators.required, Validators.pattern(this.plateRegex)]);
        } else {
          plate.setValidators([Validators.required]);
        }
        plate.updateValueAndValidity({ emitEvent: false });
        if (value) {
          this.requiredFields = this.requiredFieldsVehicleForeign || [];
          this.plateValid = plate?.value?.trim() !== '';
        } else {
          this.requiredFields = this.requiredFieldsVehicle || [];
          this.plateValid = plate.errors === null;
        }
      } else {
        const plate = this.formGroup.get('plate').value;
        if (value) {
          this.requiredFields = this.requiredFieldsVehicleForeign || [];
          this.plateValid = plate?.trim() !== '';
        } else {
          this.requiredFields = this.requiredFieldsVehicle || [];
        }
      }
      if (this.requiredFields?.length > 0) {
        this.requiredFields.forEach(field => {
          this.disabledRequiredFields[field] = true;
        });
      }
      this.setRequiredFields();
    });

    this.formGroup.get('plate').valueChanges.subscribe(value => {
      setTimeout(() => {
        this.plateValid = value?.trim() !== '' && this.formGroup.get('plate')?.errors == null;
      }, 1000);
    });

    this.formGroup.get('reasonCode').valueChanges.subscribe(value => {
      const textRequired = value !== '' ? '' : 'Este campo é requerido.';
      if (!this.violationIdsProcessed.includes(this.violation.id) && !this.isViolationInStandBy()) {
        if (value == null || value === '') {
          this.setRequiredFields();
        } else {
          this.disableValidators();
        }
        if (value) {
          const element = document.getElementById('plateInputElement') as HTMLElement;
          if (element) {
            if (element.querySelector('.form-group .text-danger span')) {
              element.querySelector('.form-group .text-danger span').textContent = textRequired;
              if (value !== '') {
                element.querySelector('.form-group input')?.classList.remove('is-invalid');
              }
            }
          }
        }
      }
    });
  }

  setForm(violation) {
    // Manter desabilitado durante todo o setForm
    this.skipPlateSearch = true;

    this.violation = violation;
    this.violationProcessed = false;
    this.currentBrandModelCode = '';
    this.processStatus();
    this.isChangesPermited();
    this.setFiles(violation);

    const originalVehicle = _.cloneDeep(violation.vehicle);
    // this.setFormPlate(originalVehicle);

    this.formGroup.controls.cityCode.setValue(null);
    this.formGroup.controls.stateId.setValue(originalVehicle.uf || null);
    this.formGroup.controls.regionId.setValue(this.regionId);
    this.formGroup.controls.foreignPlate.setValue(originalVehicle.foreignPlate || false);
    const plateControl = this.formGroup.get('plate');
    plateControl.setValue(originalVehicle.plate);
    this.formGroup.get('reasonCode').setValue((violation.reason && violation.reason.code) || '');

    if (this.violation.step === 'doubleTyping') {
      plateControl.setValue(originalVehicle.plateOCR || '');
      this.formGroup.get('reasonCode').setValue('');
    }
    if (this.violationIdsProcessed.includes(violation.id)) {
      plateControl.setValue(originalVehicle.plate);
    }
    if (plateControl.value === '') {
      this.resetForm();
    }

    this.setPlateFocus();
    for (const i in this.formGroup.controls) {
      if (this.formGroup.controls.hasOwnProperty(i)) {
        const control = this.formGroup.controls[i];
        control.markAsPristine();
      }
    }
    this.reasons = this.reasonsAll.filter(reason =>
      reason.regulationIds.includes(violation.regulationId) && reason.screen !== undefined
      && reason.screen.includes('typing'));
    this.isModified = false;

    const vehicleHasData = this.hasVehicleData(originalVehicle);
    if (plateControl.value !== '' && this.hasSearch && !vehicleHasData) {
      // Reabilitar pesquisa e executar manualmente
      this.skipPlateSearch = false;
      this.loadVehicle(plateControl.value, this.violation.step);
    } else {
      // Já tem dados, preencher o formulário
      this.setFormPlate(originalVehicle);
      this.fillVehicleFormFields(originalVehicle);
      // Reabilitar pesquisa após preencher
      this.skipPlateSearch = false;
    }

    if (this.enabledWeightClass) {
      const regulationIds = this.preProcessSettings.weightClass?.regulationIds || [];
      if (this.lanesCode.length > 0 && !this.lanesCode.includes(violation.laneCode)) {
        this.isWeighClass = false;
      } else if (regulationIds.length > 0 && !regulationIds.includes(violation.regulationId)) {
        this.isWeighClass = false;
      } else {
        this.isWeighClass = true;
      }
    }
  }

  private fillVehicleFormFields(vehicle: any): void {
    if (!vehicle) {
      return;
    }

    if (vehicle.brandModelCode) {
      this.brandModelService.list({ regionId: this.regionId, code: vehicle.brandModelCode }).then(brand => {
        const brandModel = brand.result[0];
        if (brandModel) {
          const findIndex = this.brandModels.findIndex(b => b.code === brandModel.code);
          if (findIndex < 0) {
            this.brandModels.push(brandModel);
            this.brandModels = _.sortBy(this.brandModels, 'code');
          }
          this.currentBrandModelCode = brandModel;
          this.formGroup.controls.brandModelCode.setValue(vehicle.brandModelCode);
        }
      });
    }

    if (vehicle.colorCode) {
      this.formGroup.controls.colorCode.setValue(vehicle.colorCode);
    }
    if (vehicle.year) {
      this.formGroup.controls.year.setValue(vehicle.year);
    }
    if (vehicle.categoryCode) {
      this.formGroup.controls.categoryCode.setValue(vehicle.categoryCode);
    }
    if (vehicle.classificationCode) {
      this.formGroup.controls.classificationCode.setValue(vehicle.classificationCode);
    }
    if (vehicle.typeCode) {
      this.formGroup.controls.typeCode.setValue(vehicle.typeCode);
    }
    if (vehicle.foreignPlate) {
      this.formGroup.controls.foreignPlate.setValue(vehicle.foreignPlate);
    }
    if (vehicle.modelYear) {
      this.formGroup.controls.modelYear.setValue(vehicle.modelYear);
    }
    if (vehicle.chassis) {
      this.formGroup.controls.chassis.setValue(vehicle.chassis);
    }
    if (vehicle.uf) {
      this.formGroup.controls.uf.setValue(vehicle.uf);
    }
  }

  hasVehicleData(vehicle: any): boolean {
    if (!vehicle) {
      return false;
    }

    const essentialFields = [
      'colorCode',
      'brandModelCode',
      'categoryCode',
      'typeCode'
    ];

    const filledFields = essentialFields.filter(field =>
      vehicle[field] != null && vehicle[field] !== '' && vehicle[field] !== '0'
    );

    return filledFields.length >= 2;
  }

  setRequiredFields() {
    const controls = this.formGroup.controls;
    const foreignPlate = this.formGroup.get('foreignPlate').value;
    if (this.requiredFields == null || this.requiredFields.length === 0) {
      return;
    }
    Object.keys(controls).forEach(key => {
      if (this.requiredFields.includes(key)) {
        if (this.plateRegex != null && key === 'plate' && !foreignPlate) {
          controls[key].setValidators([Validators.required, Validators.pattern(this.plateRegex)]);
        } else {
          controls[key].setValidators([Validators.required]);
        }
        controls[key].markAsDirty();
      } else {
        controls[key].clearValidators();
      }
      controls[key].updateValueAndValidity({ emitEvent: false });
    });
    this.validatorsDisabled = false;
  }

  disableValidators() {
    if (!this.validatorsDisabled) {
      Object.keys(this.formGroup.controls).forEach(control => {
        if (control !== 'plate' || this.enabledVehicleForeign) {
          this.formGroup.controls[control].clearValidators();
          this.formGroup.controls[control].updateValueAndValidity({ emitEvent: false });
        }
      });
      this.validatorsDisabled = true;
    }
  }

  setFiles(violation) {
    if (this.isDouble) {
      if (violation.files != null) {
        this.files = [];
        this.secondFiles = [];
        violation.files.forEach(f => {
          const obj = {
            src: f.urlCurrent || f.urlDecrypted,
            type: f.type,
            urlCurrent: f.urlCurrent,
            urlDecrypted: f.urlDecrypted,
            targeHeight: f.targeHeight,
            targePosition: f.targePosition
          };
          if (/zoom/.test(f.type)) {
            this.files.push(obj);
          } else if (/pan2/.test(f.type)) {
            this.secondFiles.unshift(obj);
          } else {
            this.secondFiles.push(obj);
          }
        });
        if (this.files.length !== 0 || this.secondFiles.length !== 0) {
          if (this.secondFiles.length === 0 && this.files.length > 1) {
            this.secondFiles.push(this.files.pop());
          }
          if (this.files.length === 0) {
            this.files.push(this.secondFiles.shift());
          }
        }
      }
    } else {
      this.files = [];
      violation.files.forEach(f => {
        const file = {
          src: f.urlCurrent || f.urlDecrypted,
          type: f.type,
          urlCurrent: f.urlCurrent,
          urlDecrypted: f.urlDecrypted,
          targeHeight: f.targeHeight,
          targePosition: f.targePosition
        };
        if (f.type === 'zoom') {
          this.files.unshift(file);
        } else {
          this.files.push(file);
        }
      });
    }
  }

  getViolation() {
    let violation = cloneDeep(this.violation);
    if (violation.vehicle == null) {
      violation = Object.assign(violation, { vehicle: {} });
    }
    violation.vehicle.plate = this.formGroup.get('plate').value &&
      this.formGroup.get('plate').value.toUpperCase();
    violation.vehicle.colorCode = this.formGroup.get('colorCode').value;
    violation.vehicle.year = this.formGroup.get('year') &&
      this.formGroup.get('year').value && parseInt(this.formGroup.get('year').value, 10);
    const brandModelCode = this.formGroup.get('brandModelCode').value;
    if (brandModelCode && brandModelCode !== '' && brandModelCode !== violation.vehicle.brandModelCode) {
      violation.vehicle.brandModelCode = this.formGroup.get('brandModelCode').value;
    }
    violation.vehicle.categoryCode = this.formGroup.get('categoryCode').value;
    violation.vehicle.classification =
      this.classifications.find(a => a.code === this.formGroup.get('classificationCode').value)?.description;
    violation.vehicle.color = this.colors.find(a => a.code === this.formGroup.get('colorCode').value)?.description;
    violation.vehicle.colorCode = this.formGroup.get('colorCode').value;
    violation.vehicle.year = this.formGroup.get('year').value;
    violation.vehicle.typeCode = this.formGroup.get('typeCode').value;
    violation.vehicle.cityCode = this.formGroup.get('cityCode').value;
    violation.vehicle.foreignPlate = this.formGroup.get('foreignPlate').value;
    violation.vehicle.modelYear = this.formGroup.get('modelYear').value ?
      parseInt(this.formGroup.get('modelYear').value, 10) : this.violation?.vehicle?.modelYear;
    violation.vehicle.chassis = (this.formGroup.get('chassis').value || '').trim() || this.violation?.vehicle?.chassis;
    violation.vehicle.uf = (this.formGroup.get('uf').value || '').trim() || this.violation?.vehicle?.uf;

    violation.vehicle.abbreviation = this.showingStates.filter(state => state.id === this.formGroup.get('stateId').value)[0]?.abbreviation;
    violation.vehicle.foreignPlate = this.formGroup.get('foreignPlate').value;
    if (violation.vehicle.abbreviation == null && violation.vehicle.uf != null) {
      violation.vehicle.abbreviation = violation.vehicle.uf;
    }

    violation.vehicle.length = this.violation?.vehicle?.length;
    // violation.vehicle.plateOCR = this.violation?.vehicle?.plateOCR || '';
    violation.vehicle.profile = this.violation?.vehicle?.profile;
    violation.vehicle.size = this.violation?.vehicle?.size;
    violation.vehicle.weightClassCode = this.violation?.vehicle?.weightClassCode;

    if (
      this.formGroup.get('classificationCode').value === '' ||
      this.formGroup.get('classificationCode').value === undefined
    ) {
      violation.vehicle.classificationCode = '0';
    } else {
      violation.vehicle.classificationCode = this.formGroup.get('classificationCode').value;
    }

    this.violation = violation;
    const violationIndex = this.violations.findIndex(a => a.id === violation.id);
    if (violationIndex >= 0) {
      this.violations[violationIndex] = violation;
    }
    const valueReason = this.formGroup.get('reasonCode').value;
    if (valueReason !== '') {
      const reason = this.reasons.find(r => r.code === valueReason);
      if (violation.reason == null) {
        violation = Object.assign(violation, { reason: {} });
      }
      if (this.changesPermited) {
        violation.reason = {
          code: reason.code,
          name: reason.name,
          type: reason.type || ''
        };
      }
    } else {
      delete violation.reason;
    }
    return violation;
    // return this.removeVehicleFields(violation, ['length', 'profile', 'size', 'plateOCR']);
  }

  removeVehicleFields(violation, immutableFields: string[] = ['length', 'profile', 'size', 'plateOCR']) {
    const discardFields = ['brandModel', 'category', 'city',
      'classification', 'color', 'registrationNumber',
      'type', 'uf', null, 'undefined', ''];
    for (const key of Object.keys(violation.vehicle)) {
      if (immutableFields.includes(key)) {
        continue;
      }
      if (discardFields.includes(violation.vehicle[key])) {
        delete violation.vehicle[key];
      }
    }
    return violation;
  }

  setDouble(flag) {
    if (this.isDouble !== flag) {
      this.isDouble = flag;
      this.setFiles(this.violation);
    }
  }

  async nextViolation() {
    this.cancelPendingPlateSearch();
    this.clearVehicleFormControls();
    this.currentBrandModelCode = undefined;
    this.isChangePlate = false;
    this.reasonInputSelected = false;
    if (this.imagesSettings != null) {
      await this.updateImages();
    }
    if (this.i < this.violations.length - 1) {
      this.i++;
      this.setForm(this.violations[this.i]);
      if (this.i > this.violations.length - 5) {
        this.getViolations().catch(err => { });
      }
    } else {
      const current = this.i;
      this.getViolations().then(() => {
        if (current < this.violations.length - 1) {
          this.i = current + 1;
        }
      }).catch(err => { });
    }
  }

  async prevViolation() {
    this.cancelPendingPlateSearch();
    this.clearVehicleFormControls();
    this.currentBrandModelCode = undefined;
    this.isChangePlate = false;
    this.reasonInputSelected = false;
    if (this.imagesSettings != null) {
      await this.updateImages();
    }
    if (this.i > 0) {
      this.i--;
      this.setForm(this.violations[this.i]);
    }
  }

  async validate() {
    if (this.acceptLoading === true) {
      return;
    }
    this.setRequiredFields();
    if (!this.formGroup.valid) {
      return;
    }
    this.acceptLoading = true;
    const violation = this.getViolation();
    try {
      if (this.urlSegment === 'typing' || this.urlSegment === 'doubleTyping') {
        delete violation.reason;
      }
      if (violation.reason && violation.reason.type == null) {
        delete violation.reason.type;
      }
      if (violation.step !== this.urlSegment) {
        violation.step = 'review';
      }
      await this.violationService.accept(violation).then(violationProc => {
        this.violations[this.i] = violationProc;
      });
      this.violationIdsProcessed.push(violation.id);
      this.alertService.show(new AlertItem('ViolationSaved', AlertType.success));
    } catch (err) {
      console.error(err);
      if (err.error.type === 'laneDisabled') {
        this.alertService.show(new AlertItem('FramingNotEnabledForTrack', AlertType.danger));
      } else if (err.error.type === 'violationExpired') {
        this.alertService.show(new AlertItem('ViolationExpiredToEditing', AlertType.danger));
      } else if (err.status === 409) {
        this.alertService.show(new AlertItem('ProcessedViolationAlreadyExists', AlertType.danger));
        const duplicateViolation = err.error;
        this.openMessageDuplicateViolation(duplicateViolation);
      } else {
        this.alertService.show(new AlertItem('ViolationSaveError', AlertType.danger));
      }
    }
    this.currentBrandModelCode = undefined;
    this.nextViolation();
    this.acceptLoading = false;
  }

  async updateImages() {
    const id = this.violation.id;
    for (const type of Object.keys(this.imagesSettings)) {
      const imageSettings = Object.assign({ type }, this.imagesSettings[type]);
      if (imageSettings.restore) {
        delete imageSettings.restore;
      }
      await this.violationService.updateImage(id, imageSettings)
        .then(data => {
          this.setFiles(data);
          this.alertService.show(new AlertItem('ViolationImageSaved', AlertType.success));
        })
        .catch((err) => {
          console.error(err);
          this.alertService.show(new AlertItem('ViolationImageSaveError', AlertType.danger));
        });
    }
    this.imagesSettings = null;
  }

  async restoreImage(type, imgSettings = null) {
    this.imagesSettings = imgSettings;
    await this.violationService.restoreImage(this.violation.id, { type })
      .then(data => {
        this.setFiles(data);
        this.alertService.show(new AlertItem('ViolationImageRestored', AlertType.success));
      })
      .catch((err) => {
        console.error(err);
        this.alertService.show(new AlertItem('ViolationImageRestoredError', AlertType.danger));
      });
  }

  async refused() {
    if (this.refuseLoading === true) {
      return;
    }

    this.refuseLoading = true;
    try {
      const violation = this.getViolation();
      if (this.formGroup.get('plate').value === '') {
        violation.vehicle.plate = '';
      }
      if (violation.reason && violation.reason.type == null) {
        delete violation.reason.type;
      }
      if (violation.step !== this.urlSegment) {
        violation.step = 'review';
      }
      await this.violationService.refuse(violation).then(violationProc => {
        this.violations[this.i] = violationProc;
      });
      this.violationIdsProcessed.push(violation.id);
      this.alertService.show(new AlertItem('ViolationSaved', AlertType.success));
      this.nextViolation();
    } catch (err) {
      if (err.status === 409) {
        const duplicateViolation = err.error;
        this.openMessageDuplicateViolation(duplicateViolation);
      } else if (err.error.type === 'violationExpired') {
        this.alertService.show(new AlertItem('ViolationExpiredToEditing', AlertType.danger));
      } else {
        this.alertService.show(new AlertItem('ViolationRefusedError', AlertType.danger));
        console.error(err);
      }
    }
    this.refuseLoading = false;
  }

  disableReasonInputSelected() {
    this.reasonInputSelected = false;
  }

  @HostListener('window:keydown', ['$event'])
  keyEvent(event) {
    const isCtrl = event.ctrlKey;
    switch (event.key) {
      case 'i':
        if (isCtrl && this.urlSegment === 'typing') {
          const element = this.reasonInput.nativeElement as HTMLSelectElement;
          if (element != null) {
            element.focus();
          }
          event.preventDefault();
        }
        break;
      case 'k':
        if (isCtrl) {
          this.prevViolation();
          event.preventDefault();
        }
        break;
      case 'l':
        if (isCtrl) {
          this.nextViolation();
          event.preventDefault();
        }
        break;
      case 'm':
        if (isCtrl) {
          if (this.modalService.isOpen(CommentPanelComponent)) {
            this.modalService.close();
          } else {
            this.openCommentPanel();
          }
          event.preventDefault();
        }
        break;
      case 'x':
        if (isCtrl) {
          this.openSearchPlatePanel();
        }
        break;
      case 'Enter':
        const reasonCode = this.formGroup.get('reasonCode').value;
        if ([this.plateNotFoundReasonCode, this.whitelistReasonCode].includes(reasonCode)) {
          this.refused();
        }
        break;
      case 'Tab':
        event.preventDefault();
        if (this.gb.isOn('ECS-4018')) {
          this.setTabOrderActionsV2();
        } else {
          this.setTabOrderActionsV1();
        }
        break;
    }
    this.setInactivity();
  }

  @HostListener('window:mouseup', ['$event'])
  onMouseup(event: MouseEvent) {
    this.setInactivity();
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(e) {
    this.setInactivity();
  }

  @HostListener('keydown', ['$event']) onKeydown(event) {
    const value = event.target.value;
    const foreignPlate = this.formGroup.get('foreignPlate').value;
    const enabled = this.gb.isOn('ECS-4796');
    if (enabled) {
      if (!['Delete', 'Shift', 'End', 'Alt', 'Insert', 'Home', 'Backspace',
        'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(event.key) &&
        value.length === 7 && !foreignPlate) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }

  setTabOrderActionsV1() {
    const reasonInput = this.reasonInput.nativeElement as HTMLSelectElement;
    const refuseButton = this.refuseButton.nativeElement as HTMLSelectElement;
    const confirmButton = this.confirmButton.nativeElement as HTMLElement;
    if (
      this.requiredFields.length <= 1
      && this.formGroup.get('reasonCode').value === ''
      && !this.reasonInputSelected
    ) {
      if (reasonInput != null) {
        reasonInput.focus();
        this.reasonInputSelected = true;
      }
      return;
    }
    if (
      this.requiredFields.length <= 1
      && this.formGroup.get('reasonCode').value === ''
      && !this.reasonInputSelected
    ) {
      if (confirmButton != null) {
        confirmButton.focus();
        this.reasonInputSelected = false;
      }
    }
    if (
      this.formGroup.get('reasonCode').value !== '' &&
      this.violation.status === 'invalid'
    ) {
      if (reasonInput != null) {
        reasonInput.focus();
        this.reasonInputSelected = true;
      }
    }
    if (
      this.formGroup.get('reasonCode').value !== ''
      && this.violation.reason.code !== this.formGroup.get('reasonCode').value
    ) {
      if (refuseButton != null) {
        refuseButton.focus();
        refuseButton.click();
      }
    }
    if (
      this.formGroup.get('reasonCode').value === ''
      && this.violation.status === 'invalid'
      && this.formGroup.get('plate').value !== ''
      || this.formGroup.get('reasonCode').value === ''
      && this.violation.status === 'valid'
      && this.formGroup.get('plate').value !== ''
    ) {
      if (confirmButton != null) {
        confirmButton.focus();
        confirmButton.click();
        this.reasonInputSelected = false;
      }
    }
    if (
      !this.allowInputNotFoundVehicle
      && !this.reasonInputSelected
    ) {
      if (reasonInput != null) {
        reasonInput.focus();
        this.reasonInputSelected = true;
      }
    }
  }

  setTabOrderActionsV2() {
    const confirmButton = this.confirmButton.nativeElement as HTMLButtonElement;
    const refuseButton = this.refuseButton.nativeElement as HTMLSelectElement;
    if (
      this.formGroup.get('reasonCode').value === ''
      && this.violation.status === 'invalid'
      && this.formGroup.get('plate').value !== ''
      && !this.getValue(this.preProcessSettings, 'allowInputNotFoundVehicle')
      || this.formGroup.get('reasonCode').value === ''
      && this.violation.status === 'valid'
      && this.formGroup.get('plate').value !== ''
      && !this.getValue(this.preProcessSettings, 'allowInputNotFoundVehicle')
    ) {
      if (confirmButton != null) {
        confirmButton.focus();
        confirmButton.click();
        this.reasonInputSelected = false;
      }
    } else if (
      this.formGroup.get('reasonCode').value !== ''
      && this.violation?.reason?.code !== this.formGroup.get('reasonCode').value) {
      if (refuseButton != null) {
        refuseButton.focus();
        refuseButton.click();
      }
    } else {
      // eslint-disable-next-line max-len
      let inputFields = Array.from(document.querySelectorAll('input:not(:disabled), select:not(:disabled), button:not(:disabled)'));
      inputFields = inputFields.filter(e => e.id !== 'mat-checkbox-1-input');
      const currentInputField = document.activeElement;
      const currentIndex = inputFields.indexOf(currentInputField);
      const nextInputField = inputFields[currentIndex + 1] as HTMLInputElement;
      if (nextInputField) {
        nextInputField.focus();
      } else {
        this.plateInputElement.nativeElement.querySelector('input').focus();
      }
    }
  }

  openCommentPanel() {
    this.modalService.show(new ComponentModal(CommentPanelComponent, this.violation))
      .catch(err => { });
  }

  openSearchPlatePanel() {
    let data = null;
    this.modalService.show(new ComponentModal(SearchPlatePanelComponent, this.violation))
      .then((res: SearchPlatePanelComponent) => {
        data = res;
        this.skipPlateSearch = true;
        this.setPlateFocus();
        this.vehicleData = data.component.instance.vehicleData;
        this.formGroup.get('plate').setValue(this.vehicleData.plate);
        this.formGroup.get('colorCode').setValue(this.colors.find(e => e.code === this.vehicleData.colorCode)?.code);
        this.formGroup.get('year').setValue(this.vehicleData.year);
        const findIndex = this.brandModels.findIndex(b => b.code === this.vehicleData.brandModelCode);
        if (findIndex < 0 && this.vehicleData.brandModelCode) {
          this.brandModels.push({ code: this.vehicleData.brandModelCode, description: this.vehicleData.brandModel } as any);
          this.brandModels = _.sortBy(this.brandModels, 'code');
        }
        this.formGroup.get('brandModelCode').setValue(this.vehicleData.brandModelCode);
        this.formGroup.get('displayBrandModelCode').setValue(this.vehicleData.brandModel);
        this.currentBrandModelCode = this.brandModels.find(brand => brand.code === this.vehicleData.brandModelCode);
        this.formGroup.get('categoryCode').setValue(this.vehicleData.categoryCode);
        this.formGroup.get('foreignPlate').setValue(this.vehicleData.foreignPlate);
        this.formGroup.get('classificationCode').setValue(this.vehicleData.classificationCode);
        this.formGroup.get('typeCode').setValue(this.vehicleData.typeCode);
        this.formGroup.get('modelYear').setValue(this.vehicleData.modelYear || '');
        this.formGroup.get('chassis').setValue(this.vehicleData.chassis || '');
        this.formGroup.get('uf').setValue(this.vehicleData.uf || '');
        const city: any = this.loadCitiesByCode(this.vehicleData.cityCode);
        if (city.__zone_symbol__value) {
          this.loadCities(city.stateId);
          this.formGroup.get('cityCode').setValue(city.code);
          this.formGroup.get('regionId').setValue(city.regionId);
          this.formGroup.get('stateId').setValue(city.stateId);
        } else {
          const params = {
            contractId: this.violation.contractId,
            plate: this.vehicleData.plate,
            regulationId: this.violation.regulationId,
            date: this.violation.date
          };
          this.findPlate(params);
        }
        setTimeout(() => {
          this.skipPlateSearch = false;
        }, 100);
      }).catch(err => {
        console.error(err);
      });
  }

  openHistoryPanel() {
    this.modalService.show(new ComponentModal(HistoryPanelComponent, this.violation))
      .catch(err => { });
  }

  async setFormPlate(vehicle, isSearch = false) {
    const items = ['color', 'classification', 'category', 'brandModel', 'type', 'city', 'year'];
    this.plateSearchFoundFields = [];
    items.forEach(async item => {
      const field = item === 'year' ? item : `${item}Code`;
      const value = item === 'year' ? 0 : '0';
      if (vehicle != null && vehicle[field] && this.violation.step !== 'doubleTyping') {
        this.formGroup.get(field).setValue(vehicle[field]);
        if (vehicle[field] !== '' && vehicle[field] !== value && isSearch) {
          this.plateSearchFoundFields.push(field);
        } else if (this.violation.vehicle[field] != null &&
          (this.violation.vehicle[field] === '')) {
          delete this.violation.vehicle[field];
        }
      } else if (vehicle == null || vehicle[`${item}Id`] == null) {
        if (field === 'brandModelCode' && vehicle[item] && vehicle[item] !== '' && (!vehicle[field] || vehicle[field] === '')) {
          const vehicleField = vehicle[item];
          const brandModel = {
            code: vehicleField,
            description: vehicleField,
          };
          const index = this.brandModels.findIndex(b => b.description === brandModel.code);
          if (index < 0) {
            this.brandModels.push(brandModel);
          }
          this.formGroup.get(field).setValue(vehicle[item]);
        } else {
          this.formGroup.get(field).setValue('');
        }
      } else {
        const data = await this[`${item}Service`].getById(vehicle[`${item}Id`]);
        if (data != null) {
          this.formGroup.get(field).setValue(data.code);
          if (isSearch) {
            this.plateSearchFoundFields.push(field);
          }
        }
      }
    });
    if (vehicle != null) {
      let city;
      if (vehicle.cityId != null) {
        city = this.cities && this.cities.find(c => c.id === vehicle.cityId);
      } else {
        city = this.cities && this.cities.find(c =>
          c.regionId === this.regionId && c.code === vehicle.cityCode);
      }
      if (city == null) {
        if (vehicle.cityCode != null && vehicle.cityCode !== '') {
          await this.cityService.list({ regionId: this.regionId, code: vehicle.cityCode })
            .then(async res => {
              city = res.result[0];
              await this.loadCities(city.stateId);
              await this.setCoutry(city, isSearch);
            });
        }
      } else {
        await this.loadCities(city.stateId);
        await this.setCoutry(city, isSearch);
      }
    }
  }

  async setCoutry(city, isSearch) {
    this.formGroup.get('cityCode').setValue(city.code);
    this.formGroup.get('regionId').setValue(city.regionId);
    this.formGroup.get('stateId').setValue(city.stateId);
    if (isSearch) {
      this.plateSearchFoundFields.push('cityCode');
      this.plateSearchFoundFields.push('regionId');
      this.plateSearchFoundFields.push('stateId');
    }
  }

  async loadVehicle(plateTyping: string, step) {
    // Se a flag estiver ativa, não executar a pesquisa
    if (this.skipPlateSearch) {
      return;
    }
    this.resetForm();

    const isViolationInStandBy = this.isViolationInStandBy();
    const isNotSepCurrent = this.urlSegment !== step;
    const plate = this.formGroup.get('plate');
    if (plateTyping == null || plateTyping?.trim() === '' || plate?.errors != null || plate.value.length < 7) {
      this.resetForm();
      return;
    }
    if (this.violationIdsProcessed.includes(this.violation.id) &&
      (this.violation.vehicle.plate === plateTyping || !this.isViolationInStandBy())) {
      return;
    }

    if ((this.hasSearch || this.hasWhiteList) &&
      plateTyping &&
      plateTyping !== '' &&
      this.formGroup.get('plate').valid) {
      if (this.placeDebouncer != null) {
        clearTimeout(this.placeDebouncer);
      }

      this.placeDebouncer = setTimeout(async () => {
        this.plateSearchFoundFields = [];
        const params = {
          contractId: this.violation.contractId,
          plate: plateTyping,
          regulationId: this.violation.regulationId,
          date: this.violation.date
        };
        this.violation = this.removeVehicleFields(this.violation, ['length', 'profile', 'size', 'plateOCR']);
        if ((this.violation.status === 'invalid' &&
          this.violation.reason.code === this.formGroup.get('reasonCode').value &&
          this.violation.vehicle.plate === plateTyping) ||
          this.violation.status === 'valid' && this.violation.vehicle.plate === plateTyping &&
          this.violation.reason?.code === this.formGroup.get('reasonCode').value) {
          return;
        }

        if (this.featureECS3916()) {
          const { vehicleDataSearch, enabledWhiteList } = this.preProcessSettings;
          if (!this.formGroup.get('foreignPlate').value && (vehicleDataSearch !== 'disabled' || enabledWhiteList)) {
            this.plateSearchPromise = this.findPlate(params);
          }
        } else {
          this.plateSearchPromise = this.findPlate(params);
        }
      }, 300);
    }
  }

  handleFindPlateError() {
    if (
      this.searchVehicle?.vehicle === null
      && this.getValue(this.preProcessSettings, 'allowInputNotFoundVehicle')
      || this.searchVehicle?.vehicle?.error
      && this.getValue(this.preProcessSettings, 'allowInputNotFoundVehicle')
      || !this.searchVehicle?.vehicle?.plate
      && this.getValue(this.preProcessSettings, 'allowInputNotFoundVehicle')
    ) {
      this.resetForm();
      this.alertService.show(new AlertItem('PlateNotFoundAuthorized', AlertType.warning, false, 5000));
    }

    else if (
      this.searchVehicle?.vehicle?.plate === ''
      && !this.getValue(this.preProcessSettings, 'allowInputNotFoundVehicle')
      || this.searchVehicle?.vehicle === null
      && !this.getValue(this.preProcessSettings, 'allowInputNotFoundVehicle')
      || this.searchVehicle?.vehicle?.error
      && !this.getValue(this.preProcessSettings, 'allowInputNotFoundVehicle')
      || !this.searchVehicle?.vehicle?.plate
      && !this.getValue(this.preProcessSettings, 'allowInputNotFoundVehicle')
    ) {
      if (this.hasSearch) {
        this.resetForm();
        this.alertService.show(new AlertItem('PlateNotFoundNotAuthorized', AlertType.warning, false, 3000));
      }
    }

    else if (
      this.searchVehicle?.vehicle?.plate === ''
      && this.getValue(this.preProcessSettings, 'allowInputNotFoundVehicle')
      || this.searchVehicle?.vehicle?.error
      && this.getValue(this.preProcessSettings, 'allowInputNotFoundVehicle')
      || !this.searchVehicle?.vehicle?.plate
      && this.getValue(this.preProcessSettings, 'allowInputNotFoundVehicle')
    ) {
      this.resetForm();
      this.alertService.show(new AlertItem('PlateNotFoundAuthorized', AlertType.warning, false, 5000));
    }
  }

  async findPlate(params: { contractId: string; plate: string; regulationId: string; date: Date }) {
    const targetViolationId = this.violation.id;
    this.resetForm();
    this.isSearchPlate = true;
    return this.plateService.searchPlate(params)
      .then((searchVehicle) => {
        if (this.violation.id !== targetViolationId) {
          return;
        }
        this.searchVehicle = searchVehicle;
        this.handleFindPlateError();
        const brandModelCode = searchVehicle.vehicle.brandModelCode || '';
        const brandModelDescription = searchVehicle.vehicle.brandModel || '';
        if (brandModelCode === '') {
          this.formGroup.get('brandModelCode').setValue('');
        }
        this.cetModels = false;

        if (searchVehicle?.vehicle?.plate == null && this.preProcessSettings.changeBrandModelForClientBrand) {
          this.brandModelInternal();
        }

        if (searchVehicle?.vehicle?.brandModelId) {
          this.brandModelService.getById(searchVehicle.vehicle.brandModelId).then(brandModel => {
            const findIndex = this.brandModels.findIndex(b => b.code === brandModel.code);
            if (findIndex < 0) {
              this.brandModels.push(brandModel);
              this.brandModels = _.sortBy(this.brandModels, 'code');
            }
            this.currentBrandModelCode = brandModel;
          });
        } else if (brandModelCode === '' && brandModelDescription !== '') {
          const paramsBrandModel: any = { regionId: this.regionId, description: brandModelDescription, limit: '1' };
          this.brandModelService.list(paramsBrandModel).then(async (res) => {
            let brandModel: any = res.result[0];
            if (brandModel == null) {
              brandModel = {
                code: brandModelDescription,
                description: brandModelDescription,
              };
            }
            this.formGroup.get('brandModelCode').setValue(brandModel.code);
            this.currentBrandModelCode = brandModel;
            const findBrandModelDescriptionIndex = this.brandModels.findIndex(b => b.code === brandModel.code);
            if (findBrandModelDescriptionIndex < 0) {
              this.brandModels.push(brandModel);
            }
            this.brandModels = _.sortBy(this.brandModels, 'code');
            this.violation.vehicle.brandModel = brandModelDescription;
          });
        } else if (brandModelCode !== '') {
          const findIndex = this.brandModels.findIndex(b => b.code === brandModelCode);
          if (findIndex < 0) {
            const paramsBrandModel: any = { regionId: this.regionId, code: brandModelCode, limit: '1' };
            this.brandModelService.list(paramsBrandModel).then(async (res) => {
              const brandModel: any = res.result[0];
              if (brandModel != null) {
                this.formGroup.get('brandModelCode').setValue(brandModel.code);
                this.brandModels.push(brandModel);
                this.brandModels = _.sortBy(this.brandModels, 'code');
                this.currentBrandModelCode = brandModel;
              }
            });
          }
        }

        this.formGroup.get('reasonCode').patchValue('');

        if (
          this.hasSearch && (
            searchVehicle?.vehicle?.plate === undefined
            && !this.getValue(this.preProcessSettings, 'allowInputNotFoundVehicle')
            || !searchVehicle?.vehicle?.plate
            && !this.getValue(this.preProcessSettings, 'allowInputNotFoundVehicle')
            || this.searchVehicle?.vehicle?.error
            && !this.getValue(this.preProcessSettings, 'allowInputNotFoundVehicle'))
        ) {
          const plateNotFoundReasonId = this.getValue(this.preProcessSettings, 'plateNotFoundReasonId');
          const plateNotFoundReasonCode = this.reasons.filter(a => a.id === plateNotFoundReasonId).shift();
          this.formGroup.get('reasonCode').patchValue(plateNotFoundReasonCode.code);
        }

        this.setFormPlate(searchVehicle?.vehicle, true);

        if (searchVehicle?.vehicle == null && this.hasSearch) {
          this.violation = this.removeVehicleFields(this.violation);

          if (this.preProcessSettings != null && this.preProcessSettings.allowInputNotFoundVehicle !== true) {
            this.plateFound = false;
            this.alertService.show(new AlertItem('PlateNotFoundNotAuthorized', AlertType.warning, false, 1000));
          } else {
            this.alertService.show(new AlertItem('PlateNotFoundAuthorized', AlertType.warning, false, 1000));
          }
          this.resetForm();
          return;
        }

        this.plateFound = true;

        if (searchVehicle?.vehicle?.chassis) {
          this.violation.vehicle.chassis = searchVehicle.vehicle.chassis;
          this.formGroup.get('chassis').setValue(searchVehicle.vehicle.chassis);
          this.plateSearchFoundFields.push('chassis');
        }
        if (searchVehicle?.vehicle?.modelYear) {
          this.violation.vehicle.modelYear = searchVehicle.vehicle.modelYear || 0;
          this.formGroup.get('modelYear').setValue(searchVehicle.vehicle.modelYear);
          this.plateSearchFoundFields.push('modelYear');
        }
        if ((searchVehicle?.vehicle as any)?.abbreviation) {
          this.violation.vehicle.uf = (searchVehicle.vehicle as any).abbreviation;
          this.formGroup.get('uf').setValue((searchVehicle.vehicle as any).abbreviation);
          this.plateSearchFoundFields.push('uf');
        }

        if (this.incompleteVehicleDataReasonCode != null
          && !this.getValue(this.preProcessSettings, 'allowInputNotFoundVehicle')
          && searchVehicle?.vehicle?.plate) {
          const requiredVehicleFields = this.requiredFields || [];
          const vehicle = searchVehicle?.vehicle;
          const hasIncompleteData = requiredVehicleFields.some(field => {
            const key = field === 'uf' ? 'abbreviation' : field;
            return !vehicle[key] || vehicle[key] === '' || vehicle[key] === '0' || vehicle[key] === 0;
          });
          if (hasIncompleteData) {
            this.formGroup.get('reasonCode').patchValue(this.incompleteVehicleDataReasonCode);
          }
        }

        if (searchVehicle?.vehicleWhiteList) {
          if (this.whitelistReasonCode != null) {
            this.formGroup.get('reasonCode').setValue(this.whitelistReasonCode || '');
          }
          this.alertService.show(new AlertItem(
            'PlateFoundWhitelist',
            AlertType.warning, false, 5000));
          return;
        }
      })
      .catch(err => {
        if (this.violation.id !== targetViolationId) {
          return;
        }
        if (this.preProcessSettings.changeBrandModelForClientBrand) {
          this.brandModelInternal();
        }
        console.error(err);
        if (err.status === 0 || err.status >= 500) {
          this.modalService.show(new ComponentModal(MessageSearchPlateFailedComponent, params.plate))
            .then(() => {
              if (this.violation.id !== targetViolationId) {
                return;
              }
              this.loadVehicle(params.plate, this.violation.step);
            }).catch(() => { });
        }
      }).finally(() => {
        this.isSearchPlate = false;
      });
  }

  async getBrandInternal() {
    const changeBrandModelForClientBrand = this.getValue(this.preProcessSettings, 'changeBrandModelForClientBrand');
    if (changeBrandModelForClientBrand) {
      this.cetModels = true;
      if (this.brandInternalModels.length === 0) {
        await this.brandInternalService.list({ contractId: this.contractId }).then(res => {
          const brandModels = res.result;
          brandModels.map(brand => {
            brand.description = `${brand.code} - ${brand.description}`;
          });
          this.brandInternalModels = brandModels;
        });
      }
    }
  }

  getValue(model, attr, value = '') {
    let arr = [];
    if (typeof attr === 'string') {
      arr = attr.split('.');
    } else {
      arr = attr;
    }
    if (arr.length > 0) {
      if (model[arr[0]] == null) {
        return value;
      } else {
        return this.getValue(model[arr[0]], arr.slice(1), value);
      }
    } else {
      return model;
    }
  }

  async loadCities(stateId) {
    if (stateId == null || stateId === '') {
      this.showingCities = [];
      return;
    }
    this.showingCities = this.cities.filter(c => c.stateId === stateId);

    if (this.showingCities != null && this.showingCities.length === 0) {
      this.showingCities = await this.cityService.getAll({ regionId: this.formGroup.get('regionId').value, stateId });
      this.cities = this.cities.concat(this.showingCities);
    }
    this.showingCities = _.sortBy(this.showingCities, 'name');
    this.stateTextCities = true;
  }

  async loadCitiesByCode(code) {
    if (code == null || code === '') {
      this.showingCities = [];
      return;
    }
    this.showingCities = this.cities.filter(c => c.code === code);

    if (this.showingCities != null && this.showingCities.length === 0) {
      this.showingCities = await this.cityService.getAll({ regionId: this.formGroup.get('regionId').value, code });
      this.cities = this.cities.concat(this.showingCities);
    }
    this.showingCities = _.sortBy(this.showingCities, 'name');
    this.stateTextCities = true;
    return this.showingCities.shift();
  }

  setInactivity() {
    if (this.timeoutId != null) {
      clearTimeout(this.timeoutId);
    }
    if (this.expired === true) {
      return;
    }
    this.timeoutId = setTimeout(() => {
      this.expired = true;
      this.modalService.show(new MessageModal('Sessão expirada',
        'Sua sessão foi encerrada automaticamente por inatividade. ' +
        'Você será redirecionado para a tela de Pré-Processamento. ' +
        'Para continuar processando as infrações é necessário acessar esta funcionalidade novamente', false))
        .finally(() => {
          this.unlock();
          setTimeout(() => {
            this.router.navigate(['/pre-process/']);
          }, 1000);
        });
    }, 900000);
  }

  openMessageDuplicateViolation(violation) {
    this.modalService.show(new ComponentModal(MessageDuplicateViolationModalComponent, violation))
      .then(data => {
      }).catch(err => { });
  }

  isChangesPermited() {
    if (this.violationProcessed) {
      this.changesPermited = false;
    } else {
      this.changesPermited = true;
    }
  }

  processStatus() {
    if (
      (this.stepGroup === 'typing' && !(this.violation.step === 'typing' || this.violation.step === 'doubleTyping') &&
        !this.isViolationInStandBy())
    ) {
      this.formGroup.get('reasonCode').disable();
      this.violationProcessed = true;
    } else {
      this.formGroup.get('reasonCode').enable();
      this.violationProcessed = false;
    }
  }

  editEvent(key) {
  }

  resetForm() {
    if (this.skipPlateSearch) {
      return;
    }
    setTimeout(() => {
      if (
        this.violation.vehicle.plate !== undefined &&
        this.formGroup.get('plate').value === this.violation.vehicle.plate &&
        !this.isSearchPlate &&
        this.violation.status !== 'invalid'
      ) {
        return;
      }
      if (
        this.violation.status === 'invalid' &&
        this.violation.vehicle.year
      ) {
        return;
      }
      this.clearVehicleFormFields();
    }, 50);
  }

  private cancelPendingPlateSearch() {
    if (this.placeDebouncer != null) {
      clearTimeout(this.placeDebouncer);
      this.placeDebouncer = null;
    }
  }

  private clearVehicleFormControls() {
    this.formGroup.get('colorCode').setValue('');
    this.formGroup.get('year').setValue('');
    this.formGroup.get('brandModelCode').setValue('');
    this.formGroup.get('categoryCode').setValue('');
    this.formGroup.get('classificationCode').setValue('');
    this.formGroup.get('typeCode').setValue('');
    this.formGroup.get('cityCode').setValue('');
    this.formGroup.get('stateId').setValue('');
    this.formGroup.get('regionCode').setValue('');
    this.formGroup.get('regionId').setValue('');
    this.formGroup.get('modelYear').setValue('');
    this.formGroup.get('chassis').setValue('');
    this.formGroup.get('uf').setValue('');
  }

  private clearVehicleFormFields() {
    this.clearVehicleFormControls();
    this.resetVehicle();
  }

  resetVehicle() {
    delete this.violation.vehicle.colorCode;
    delete this.violation.vehicle.color;
    delete this.violation.vehicle.year;
    delete this.violation.vehicle.brandModelCode;
    delete this.violation.vehicle?.brandModel;
    delete this.violation.vehicle.categoryCode;
    delete this.violation.vehicle.typeCode;
    delete this.violation.vehicle.cityCode;
    delete this.violation.vehicle.chassis;
    delete this.violation.vehicle.modelYear;
    delete this.violation.vehicle.abbreviation;
    delete this.violation.vehicle.category;
    delete this.violation.vehicle.city;
    delete this.violation.vehicle.type;
    delete this.violation.vehicle.uf;
    delete this.violation.vehicle.stateId;
    delete this.violation.vehicle.regionCode;
    delete this.violation.vehicle.regionId;
    delete this.violation.vehicle.foreignPlate;
    const violationIndex = this.violations.findIndex(a => a.id === this.violation.id);
    if (violationIndex >= 0) {
      this.violations[violationIndex] = this.violation;
    }
  }

  disabledReasonCodeButton() {
    const plate = this.formGroup.get('plate').value;
    const validatePlate = !plate || plate?.trim() === '' || this.plateValid;
    if (this.formGroup.get('plate').value !== '' && this.formGroup.get('reasonCode').value !== ''
      && !this.getValue(this.preProcessSettings, 'allowInputNotFoundVehicle')) {
      return false;
    }
    if ((this.formGroup.get('reasonCode').value !== '' && validatePlate)) {
      return false;
    } else {
      return true;
    }
  }

  openSearchBrandModels() {
    if (this.viewSearchBrandModels) {
      this.viewSearchBrandModels = false;
    } else {
      this.viewSearchBrandModels = true;
    }
  }

  setBrandModelCode(brandModel) {
    this.currentBrandModelCode = brandModel;
    this.formGroup.get('brandModelCode').patchValue(brandModel.code);
    this.viewSearchBrandModels = false;
  }

  searchBrandModel(event) {
    if (event.target.value !== '') {
      this.brandModelService.list({
        limit: '500',
        regionId: this.regionId,
        'description[like]': `[%${event.target.value.toUpperCase()}%]`
      }).then(res => {
        this.brandModels = res.result;
      });
    }
  }

  brandModelInternal() {
    if (this.preProcessSettings != null && this.preProcessSettings.allowInputNotFoundVehicle !== true) {
      this.plateFound = false;
      this.resetForm();
      if (this.preProcessSettings.plateNotFoundReasonId != null) {
        this.formGroup.get('reasonCode').setValue(this.plateNotFoundReasonCode || '');
      }
      this.alertService.show(new AlertItem(
        'PlateNotFoundNotAuthorized', AlertType.warning, false, 1000));
    } else {
      this.resetForm();
      this.alertService.show(new AlertItem('PlateNotFoundAuthorized', AlertType.warning, false, 1000));
      if (this.requiredFields.includes('brandModelCode')) {
        this.brandModelService.list({ regionId: this.regionId, limit: '500' }).then(res => {
          this.brandModels = res.result;
        });
      }
    }
    this.getBrandInternal();
  }

  isViolationInStandBy() {
    if (this.preProcessSettings.enabledViolationStandBy && this.violation.typingAuthorId > 0) {
      const dataExperid = moment(this.violation.modifiedAt)
        .add(this.preProcessSettings.maxPeriodViolationStandBy, 'minutes').tz(this.violation.timezone).format();
      if (dataExperid) {
        const now = moment().tz(this.violation.timezone).format();
        if (dataExperid > now) {
          return true;
        } else {
          return false;
        }
      }
    }
    return false;
  }

  featureECS3916() {
    const enabled = this.gb.isOn('ECS-3916');
    return enabled;
  }

  get isConfirmButtonDisabled(): boolean {
    this.ecs3916 = this.featureECS3916();
    const isSearchPlate = this.ecs3916 && this.isSearchPlate;
    const enabled = this.gb.isOn('ECS-4796');
    if (enabled) {
      const plate = this.formGroup.get('plate')?.value;
      if (plate?.length > 0 && !this.plateValid) {
        this.formGroup.get('reasonCode').disable();
      } else {
        this.formGroup.get('reasonCode').enable();
      }
    }
    return (
      !this.plateValid ||
      !this.typingValid ||
      this.isLoadListViolation ||
      (this.violationIdsProcessed.includes(this.violation.id) && this.formGroup.get('reasonCode')?.value !== '') ||
      !this.formGroup.valid ||
      isSearchPlate
    );
  }
}
